/** @format */

import GridItem from '../../../../../components/Grid/GridItem';
import I18n from '../../../../../components/Translate/I18n';
import GridContainer from '../../../../../components/Grid/GridContainer';
import CheckBoxSimple from '../../../../../components/Form/CheckBoxSimple';
import React, { useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { BoolTranslateTrueFalseHelper } from '../../../../../helpers/BoolTranslateHelper';

interface MultiInputPropsInterface {
    parameter: any;
    parameterKey: string;
    createValuesFromForm: (paramName: string, objectValue: object) => void | null;
    assignedValue?: any;
    isBME?: boolean;
    readOnly?: boolean;
}

export const RadioInput = (props: MultiInputPropsInterface): React.ReactElement => {
    const { parameter, parameterKey, createValuesFromForm, assignedValue, readOnly } = props;
    const [inputValue, setInputValue] = useState<any>(assignedValue ? assignedValue.allowedValue.value : null);
    const [defaultValue, setDefaultValue] = useState<any>(assignedValue ? assignedValue.default : parameter.default);
    const [isRequired, setIsRequired] = useState<boolean>(assignedValue ? assignedValue.required : props.parameter.required);

    const getValueOrArrayOfValues = (item: any): Array<string | number | boolean> => {
        if (item) {
            if (Array.isArray(item)) {
                return item.map((el: { value: any }) => el.value);
            } else {
                return [item];
            }
        }
        return [];
    };

    const [allowedValue, setAllowedValue] = useState<Array<string | number | boolean>>(
        assignedValue ? getValueOrArrayOfValues(assignedValue.allowedValue) : []
    );

    const availableValueCallback = (event: any): void => {
        const val = parameter.type === 'number' ? parseInt(event.target.value) : event.target.value;
        if (allowedValue.includes(val)) {
            const newAll = allowedValue.filter((el: any) => {
                return el !== val;
            });
            setAllowedValue(newAll);

            let finalObject = {
                default: defaultValue,
                allowedValue: newAll.map((el) => {
                    if (typeof el === 'string') {
                        if (el === 'true') {
                            return {value: true};
                        } else if (el === 'false') {
                            return {value: false};
                        } else {
                            return el;
                        }
                    }
                }),
                required: isRequired,
            };

            createValuesFromForm(parameterKey, finalObject);
        } else {
            const newAll = [...allowedValue, val];
            setAllowedValue(newAll);

            let finalObject = {
                default: defaultValue,
                allowedValue: newAll.map((el) => {
                    if (typeof el === 'string') {
                        if (el === 'true') {
                            return {value: true};
                        } else if (el === 'false') {
                            return {value: false};
                        } else {
                            return el;
                        }
                    }
                }),
                required: isRequired,
            };

            createValuesFromForm(parameterKey, finalObject);
        }
    };

    return (
        <GridContainer>
            <GridItem xs={4}>
                <I18n trans={'prov:feature.param_name'} valueObject={{ param_name: parameterKey }} />
            </GridItem>
            <GridItem xs={8}>
                <GridContainer>
                    <GridItem xs={12}>
                        <CheckBoxSimple
                            label={'prov:feature.required'}
                            checked={isRequired}
                            callback={(): void => {
                                setIsRequired(!isRequired);

                                let finalObject = {
                                    default: defaultValue,
                                    allowedValue: inputValue
                                        ? {
                                              value: inputValue,
                                          }
                                        : [],
                                    required: !isRequired,
                                };

                                createValuesFromForm(parameterKey, finalObject);
                            }}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <GridContainer>
                            <GridItem xs={12}>
                                <I18n trans={'prov:feature.default'} />
                            </GridItem>
                            <GridItem xs={12}>
                                <RadioGroup
                                    name="radio_elements"
                                    value={defaultValue}
                                    onChange={(event): void => {
                                        setDefaultValue(event.target.value === 'true');

                                        let finalObject = {
                                            default: event.target.value === 'true',
                                            allowedValue: inputValue
                                                ? {
                                                      value: inputValue,
                                                  }
                                                : [],
                                            required: isRequired,
                                        };
                                        createValuesFromForm(parameterKey, finalObject);
                                    }}
                                >
                                    {parameter.allowedValue &&
                                        parameter.allowedValue.map((item: { value: string | number | boolean }) => {
                                            return (
                                                <GridItem xs={12} key={`default_radio_element_${item.value}`}>
                                                    <FormControlLabel
                                                        value={item.value}
                                                        control={<Radio />}
                                                        label={
                                                            <I18n
                                                                trans={
                                                                    typeof item.value === 'boolean'
                                                                        ? BoolTranslateTrueFalseHelper(item.value)
                                                                        : item.value
                                                                }
                                                            />
                                                        }
                                                    />
                                                </GridItem>
                                            );
                                        })}
                                </RadioGroup>
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem xs={6}>
                        <GridContainer>
                            <GridItem xs={12}>
                                <I18n trans={'prov:feature.allowed_value'} />
                            </GridItem>
                            <GridItem xs={12}>
                                {parameter.allowedValue &&
                                    Array.isArray(parameter.allowedValue) &&
                                    parameter.allowedValue.map((item: any) => {
                                        return (
                                            <GridItem xs={12} key={`default_radio_element_${item.value}`}>
                                                <FormControlLabel
                                                    value={item.value}
                                                    control={
                                                        <Checkbox
                                                            disabled={readOnly ?? false}
                                                            checked={allowedValue.includes(item.value.toString())}
                                                        />
                                                    }
                                                    label={
                                                        <I18n
                                                            trans={
                                                                typeof item.value === 'boolean'
                                                                    ? BoolTranslateTrueFalseHelper(item.value)
                                                                    : item.value
                                                            }
                                                        />
                                                    }
                                                    onChange={availableValueCallback}
                                                />
                                            </GridItem>
                                        );
                                    })}
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};
